<mat-form-field [formGroup]="parentFormGroup">
    <input type="text"
           matInput
           [formControlName]="parentFormControlName"
           [matAutocomplete]="auto"
           [matAutocompleteDisabled]="autocompleteOff">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayElementProcessor" (optionSelected)="changeSelection($event)">
        <mat-option *ngFor="let option of optionList| async | keyvalue" [value]="valueElement(option.value)" [id]="option.key">
           {{displayOptionElement(option.value)}}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>

